import React from "react";
import Logo from "../../assets/user/images/logo.svg";

const Subscription = () => {
  return (
    <div className="container-fluid" style={{ background: "#1d364e" }}>
      <div className="d-flex align-items-center justify-content-center">
        <img src={Logo} width={300} className="mt-3" />
      </div>
      <div className="p-4">
        <h3
          className="text-center"
          style={{ color: "#bfc3cb", fontWeight: "600" }}
        >
          Subscription Plan Purchase Agreement
        </h3>
        <p>
          THIS SUBSCRIPTION PLAN PURCHASE AGREEMENT (''Agreement") is entered
          into as of the earlier of the date of execution, online acceptance of
          these terms or receipt of a prepayment ("Effective Date") by and
          between Care Exchange, Inc. having its principal place of business at
          10970 Arrow Route, Suite 206, Rancho Cucamonga, CA 91730("Care
          Exchange, Inc") and the party countersigning the Agreement, accepting
          the terms online or otherwise prepaying or paying for Subscription
          Plans from Care-Exchange.com ("Subscription Plan Purchaser" or
          ''Advertiser") for the mutual promises contained herein and other good
          and valuable consideration, receipt and adequacy of which are hereby
          acknowledged. Care Exchange, Inc and Subscription Plan Purchaser agree
          to be legally bound as follows:
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>1. Agreement</h4>
        <p>
          1.1 This Agreement along with the mutually agreed upon Purchase order,
          attached hereto and made a part hereof ("Purchase Order") and/or any
          services requested by Subscription Plan Purchaser via Care-Exchange's
          online account portal (the "Portal"), shall define Care Exchange,
          Inc's and Subscription Plan Purchaser's obligations with respect to
          Care Exchange, Inc's delivery of Subscription Plans via an mechanism
          including, but not limited to, email, fax, SMS, through the Portal,
          posting or any other method ("Subscription Plans"). In the event of a
          conflict between this Agreement, a Purchase Order, and the Portal, the
          terms and conditions of the Purchase Order, the Portal and then the
          Agreement shall govern in that order. Modifications to the Purchase
          Order or other Subscription Plan purchases may be made by emails
          between the parties.
        </p>
        <p>
          1.2 In the course of fulfilling the Purchase Order and/or Portal
          obligations, Care Exchange, Inc may use affiliates, exchanges,
          networks, publishers, internet advertisers, tracking system vendors,
          developers, creative agencies and individuals, call centers,
          consultants and agents (collectively "Care Exchange, Inc Partners").
        </p>
        <p>
          1.3 Subscription Plan Purchaser understands that Care Exchange, Inc in
          due diligence cannot monitor all host sites for appropriate content
          and makes no representations with respect to content on any website.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>2. Creative</h4>
        <p>
          In the event Subscription Plan Purchaser provides any content,
          creative or other materials to Care Exchange, Inc hereunder, the terms
          and conditions of this Section shall apply.
        </p>
        <p>
          2.1 Subscription Plan Purchaser shall provide all creative,
          substantive and other marketing materials in connection with marketing
          a Campaign, including but not limited to, banners, language/text for
          promotional email text, links, key words and any other creative
          content as needed, including, but not limited to, the use of
          alternative text-based creative (collectively "Creative"). To the
          extent Care Exchange, Inc provides assistance, collaterals, mini-sites
          (including mini-sites using Care Exchange, Inc. forms), or other
          materials in the development of a Campaign, such assistance,
          collaterals or materials shall also be Creative. Subscription Plan
          Purchaser is solely responsible for the content of all Creative and
          Campaigns including claims made by such advertisement's subject lines,
          from lines and all other material that is made available to the public
          including all compliance issues. Care Exchange, Inc. shall have no
          liability for any claims arising out of the Creative that has been
          approved by Subscription Plan Purchaser including, but not limited to
          Creative derived from Care Exchange, Inc. For purposes of approval,
          email approval shall be sufficient and approval shall not be required
          for changes to the HTML for tracking and hosting purposes, resizing
          the creative for deliverability performance, and chances for
          compliance purposes such as address and unsubscribe linking.
        </p>
        <p>
          2.2 Subscription Plan Purchaser agrees to confirm the correct function
          and legal compliance of all Creative and approve all Creative within
          twenty-four (24) hours of Care Exchange, Inc.'s request for approval.
          If no confirmation is received within this timeframe, the Creative
          shall be deemed functioning properly, in full compliance with all laws
          and regulations, accurately representing the products and services
          advertised, and approved. All problems related to Creative should be
          immediately brought to the attention of Care Exchange, Inc. Care
          Exchange, Inc is not liable for errors in position and/or placement of
          the Creative, typographic errors of any kind or other liabilities
          arising out of the Creative.
        </p>
        <p>
          2.3 Subscription Plan Purchaser agrees to allow Care Exchange, Inc. to
          make changes or alterations to the Creative as necessary to support
          the Campaigns. Care Exchange, Inc may, at its option, modify the
          flight date of a Campaign if the Creative or linking URL's are not
          delivered on time or there are delays due to third party ad-serving,
          inventory fluctuation or other issues beyond Care Exchange, Inc.'s
          control.
        </p>
        <p>
          2.4 Subscription Plan Purchaser hereby grants to Care Exchange, Inc.
          and Care Exchange, Inc. Partners a nonexclusive, worldwide,
          royalty-free, license to market, display, perform, copy, transmit,
          distribute, and promote the Campaign(s) in connection with its
          obligations hereunder.
        </p>
        <p>
          2.5 Subscription Plan Purchaser understands that Care Exchange, Inc.
          in due diligence cannot monitor all host sites for appropriate content
          and makes no representations with respect to content on any website
          where Campaigns are placed. If Subscription Plan Purchaser reasonably
          determines that the placement of any Campaign by Care Exchange, Inc.
          harms the goodwill or reputation of Subscription Plan Purchaser or
          disparages or brings Subscription Plan Purchaser into disrepute, then
          Care Exchange, Inc. shall promptly notify all offending publishers and
          affiliates to cease mailing and removal of the Campaign shall be
          completed within ten (10) business days following Subscription Plan
          Purchaser's written notice thereof to Care Exchange, Inc.; provided,
          however, that if Care Exchange, Inc. reasonably believes that removal
          of a Campaign from a website will have a material impact on Care
          Exchange, Inc.'s ability to perform in accordance with the applicable
          Purchase Order and/or the Portal, Care Exchange, Inc. may have an
          extension of the flight dates or other accommodation.
        </p>
        <p>
          2.6 Care Exchange, Inc. does not prescreen or attempt to censor or
          review any advertisement or Creative. Care Exchange, Inc. expressly
          reserves the right to: (i) refuse any advertising request, cancel any
          Campaign, or change any Campaign that does not completely conform to
          every material detail, instruction, method, and guideline set forth in
          an Purchase Order and/or the Portal; (ii) refuse any Creative that
          does not arrive forty-eight (48) hours prior to the start date; (iii)
          refuse or cancel the use of any Campaign that it deems inappropriate;
          or (iv) refuse at any time to publish or transmit any copy, photograph
          or illustration of any kind for any reason including those that it
          believes are an invasion of privacy, are degrading, libelous,
          unlawful, profane, obscene, pornographic, tend to ridicule or
          embarrass, are in bad taste, or which in its discretion are an
          infringement on a trademark, trade name, copyright, or other
          proprietary right belonging to others. All Campaigns are subject to
          capacity limitations which include software, hardware, bandwidth,
          inventory availability, payment terms, Creative performance, and
          market pricing limitations.
        </p>
        <p>
          2.7 For each Campaign that will be distributed via email the
          Subscription Plan Purchaser shall provide a postal address and a
          non-mis Subscription Planning and accurate "Subject Line" and "From
          Line" for compliance with the CAN-SPAM Act of 2003 and all other
          federal and state laws, rules and regulations.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>3. Tracking</h4>
        <p>
          3.1 Subscription Plan Purchaser acknowledges that Care Exchange,
          Inc.'s tracking system for Subscription Plans shall be deemed correct.
          When Care Exchange, Inc. is providing Subscription Plan data to
          Subscription Plan Purchaser, Subscription Plan Purchaser shall pay for
          such Subscription Plan in accordance with the Purchase Order and/or
          Portal. Care Exchange, Inc. shall have the right to place tracking
          codes on Advertiser's websites, Creative or other assets as may be
          required to track and provide estimated statistics.
        </p>
        <p>
          3.2 Each Campaign that will be distributed via email shall contain a
          functioning unsubscribe mechanism in accordance with applicable laws,
          which, when activated by a user, will actually and permanently remove
          the user's email address from the Advertiser's database. Advertiser
          shall maintain a master suppression list that includes the email
          addresses of all users that have activated the Advertiser's
          unsubscribe link or otherwise asked to be removed from Advertiser's
          email list. Advertiser shall provide such master suppression list to
          Care Exchange, Inc. on a weekly basis (or such shorter time as Care
          Exchange, Inc. determines to be necessary in order to comply with
          applicable law) in the format specified by Care Exchange, Inc. so that
          Care Exchange, Inc. and its affiliates may synchronize their own
          master suppression lists against Advertiser's suppression list.
        </p>
        <p>
          3.3 Care Exchange, Inc does not screen Subscription Plans for their
          ability to pay for any products or services offered by Subscription
          Plan Purchaser and is not responsible for any non­ payment to
          Subscription Plan Purchaser by Subscription Plans.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>4. Billing</h4>
        <p>
          4.1 Unless otherwise agreed in writing, all payments for Subscription
          Plans and delivered shall be in accordance with Care Exchange, Inc's
          tracking data described in the Purchase Order and/or Portal. Unless
          otherwise provided in a Purchase Order and/or the Portal, all payments
          will be made in advance. Subscription Plan Purchaser shall pay the
          prepayment described in the applicable Purchase Order, Portal, and/or
          as otherwise agreed. If Subscription Plan Purchaser receives invoices,
          invoices will be submitted weekly or on an as needed basis with
          payment due seven (7) days from the date of invoice (which may be sent
          by email and/or postal mail). All payments must be in U.S. funds
          unless specified differently on the Purchase Order and/or the Portal.
          In the event Subscription Plans are paid for via credit card, Care
          Exchange, Inc will not send an invoice, but will email a receipt or
          otherwise make a receipt available on the Portal.
        </p>
        <p>
          4.2 In the event of a dispute between Subscription Plan Purchaser and
          Care Exchange, Inc regarding amounts due, or upon failure of a
          third-party's tracking mechanism, Subscription Plan Purchaser agrees
          that Care Exchange, Inc's tracking count shall be applied and
          Subscription Plan Purchaser shall make the applicable payments despite
          such failure. In the event that Care Exchange, Inc does not receive a
          written notification of a disputed bill, with rationale and support
          specifically set forth therein, within seven (7) days from the date of
          the invoice, such invoice will be deemed valid and payable and may not
          thereafter be disputed. Subscription Plan Purchaser acknowledges Care
          Exchange, Inc's reliance upon this provision in making payments to
          participants in its network.
        </p>
        <p>
          4.3 Any late payments will accrue interest equal to one and one half
          percent (1.5%) per month or the maximum amount allowable under law,
          whichever is less. Care Exchange, Inc shall be entitled to recover all
          reasonable costs of collection (including agency fees, attorneys'
          fees, expenses and costs) incurred in attempting to collect payment
          from Subscription Plan Purchaser.
        </p>
        <p>
          4.4 In the event that Care Exchange, Inc allows payment by credit card
          and Subscription Plan Purchaser pays with credit card, Subscription
          Plan Purchaser expressly agrees not to charge back on the credit card
          account. In the event of a charge back, Subscription Plan Purchaser
          agrees to immediately reinstate the payment in favor of Care Exchange,
          Inc and to pay a reinstatement service fee in the amount of $75.00.
          Any and all transaction fees imposed upon Care Exchange, Inc for the
          payment by a credit card will be the Subscription Plan Purchaser's
          responsibility.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>5. Warranties</h4>
        <p>
          {" "}
          5.1 Subscription Plan Purchaser represents and warrants, on behalf of
          itself and the products and services it advertises, that: (i) it holds
          all necessary rights to permit the use of all Creative and other
          materials provided to Care Exchange, Inc.; (ii) that the use,
          reproduction, distribution, transmission or display of any Creative
          and any materials to which users can link, any products or services
          made available through the Creative, or the use of any data collected
          through a Creative or Campaign will not (A) violate any federal,
          state, or local law, rule, regulation, or policy (including but not
          limited to the Medicare, Medicaid, and Veterans' Administration
          marketing policies, Federal Trade Commission Act, CAN-SPAM Act of 2003
          and/or any applicable rules or regulations of the Federal Trade
          Commission, UK Data Protection Act of 1998 and amendments thereto and
          all other laws governing advertising practices on the Internet), give
          rise to criminal or civil liability or infringe any copyright, patent,
          trademark or service mark, trade secret rights, proprietary rights, or
          any other personal, moral, contract, property or privacy right of any
          third party (collectively "Unlawful Conduct"); (B) contain or promote
          viruses, obscene, abusive, violent, bigoted, hate-oriented, cracking,
          or hacking (collectively "Offensive Conduct"); or (C) encourage
          conduct that would constitute Unlawful Conduct or Offensive Conduct;
          (iii) all products and/or services it provides to the Subscription
          Plan shall be provided in accordance with the products/services
          specifications and in compliance with all laws, rules, regulations,
          and standards; (iii) it has the right to provide the products and/or
          services to the Subscription Plans; (iv) it has a reasonable basis for
          all claims made within the Creative, possesses appropriate
          documentation to substantiate such claims and shall fulfill all
          commitments made in its Campaigns; (v) the landing page for each
          Campaign (i.e., the Advertiser's website page where a consumer is
          directed when the consumer clicks on the Creative, fills in a
          registration form or takes a similar action or a mini-site created by
          Care Exchange, Inc.) contains a prominent link to Advertiser's privacy
          policy, which policy provides, at a minimum, adequate notice,
          disclosure and choices to consumers regarding Advertiser's use,
          collection, disclosure and security of their personal information;
          (vi) all consumer data collected by Subscription Plan Purchaser shall
          only be used for legal purposes; (vii) no data collected shall be used
          for online preference marketing absent consumer's express consent
          obtained after clear and conspicuous notice of such potential use;
          (viii) no products and/or services is targeted to children under the
          age of eighteen (18) and/or offers products or services that are
          illegal for minors to buy, possess or participate in; (ix) it will not
          load any computer program onto an individual's computer, in connection
          with the Campaign, including without limitation programs commonly
          referred to as adware or spyware but excluding cookies, without Care
          Exchange, Inc.'s prior written approval and the individual's express
          consent after receiving clear and conspicuous notice about the nature
          of the application to be downloaded; and (x) Subscription Plan
          Purchaser shall fulfill any and all commitments made with respect to
          its products and/or services and contained in its Creative.
        </p>
        <p>
          5.2 Each party represents and warrants that it has the full right,
          power, legal capacity, and authority to enter into, deliver and fully
          perform under this Agreement. Any agency agreeing this Agreement on
          behalf of an advertiser client, represents and warrants that it has
          the authority to bind its client to the terms stated herein and
          remains jointly and severally liable for all obligations under this
          Agreement and shall provide written proof of such authority.
        </p>
        <p>
          5.3 Subscription Plan Purchaser represents and warrants that any fees
          paid to Care Exchange, Inc. under this Agreement, an Purchase Order
          and/or the Portal shall not be derived from any federal, state or
          municipal governmental agency assistance program funds, which programs
          prohibit use of such funds for the purpose of buying Subscription
          Plans.
        </p>
        <p>
          5.4 Subscription Plan Purchaser agrees to defend, indemnify and hold
          Care Exchange, Inc., its third party media placement sources, third
          party publishers and list providers, Care Exchange, Inc Partners and
          their respective affiliates, employees, officers, agents, directors
          and representatives, harmless from all allegations, claims, actions,
          causes of action, lawsuits, damages, liabilities, obligations, costs
          and expenses (including without limitation reasonable attorneys' fees,
          court costs and witness fees) arising out of or related to any claim
          (i) of a breach of warranty; (ii) of failure of Subscription Plan
          Purchaser's products and/or services, the Campaign or the Creative to
          comply with applicable laws, rules or regulations; (iii) regarding the
          Campaign or Creative or the product or service advertised by the
          Campaign or Creative or provided to the Subscription Plan; (iv) breach
          of this Agreement; or (v) related to or arising out of use by
          Subscription Plan Purchaser of federal, state or municipal
          governmental agency funds for payment of fees pursuant to this
          Agreement, an Purchase Order, and/or the Portal. Advertiser agrees to
          defend Care Exchange, Inc, its third party media placement sources,
          third party publishers and list providers, Care Exchange, Inc Partners
          and their respective affiliates, employees, officers, agents,
          directors and representatives, at Care Exchange, Inc.'s sole
          discretion
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>6. Limitations of Warranties and Liability</h4>
        <p>
          6.1 THE SERVICES AND CAMPAIGNS PROVIDED BY CARE EXCHANGE, INC, ANY
          CREATIVE OR SUBSCRIPTION PLAN PROVIDED BY CARE EXCHANGE, INC, ITS USE
          AND THE RESULTS OF SUCH USE ARE PROVIDED ON AN ''AS IS," ''AS
          AVAILABLE" BASIS. TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO
          APPLICABLE LAW, CARE EXCHANGE, INC MAKES NO WARRANTIES (INCLUDING THE
          IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, AND NON-INFRINGEMENT), GUARANTEES, REPRESENTATIONS, PROMISES,
          STATEMENTS, ESTIMATES, CONDITIONS, OR OTHER INDUCEMENTS, EXPRESS,
          IMPLIED, ORAL, WRITTEN, OR OTHERWISE, EXCEPT AS EXPRESSLY SET FORTH
          HEREIN. CARE EXCHANGE, INC DOES NOT WARRANT OR GUARANTEE CONVERSION
          RATES, PAY-UP RATES, RESPONSE RATES OR ABILITY TO CONVERT THE
          SUBSCRIPTION PLANS INTO SALES. CARE EXCHANGE, INC DOES NOT WARRANT OR
          GUARANTEE THE PROFILE OR DEMOGRAPHICS OF A RESPONDENT OR A
          RESPONDENT'S ABILITY TO PAY FOR SUBSCRIPTION PLAN PURCHASER'S PRODUCTS
          OR SERVICES. CARE EXCHANGE, INC DOES NOT GUARANTEE TO MATCH COLORS,
          TEXT, PHOTO IMAGE OR SCREEN DESIGN. THE PORTAL AND ALL PURCHASE ORDERS
          ARE CONTINGENT UPON CARE EXCHANGE, INC'S ABILITY TO PROCURE NECESSARY
          ONLINE ACCESS AND CARE EXCHANGE, INC IS NOT RESPONSIBLE FOR DELAYS
          CAUSED BY FORCE MAJURE, ACCIDENT, WAR, ACT OF GOD, EMBARGO, COMPUTER
          SYSTEM FAILURE, OR ANY OTHER CIRCUMSTANCE BEYOND ITS CONTROL. CARE
          EXCHANGE, INC WILL USE REASONABLE EFFORTS TO MEET SCHEDULED DELIVERY
          AND ONLINE DATES, BUT MAKES NO GUARANTEE AND ACCEPTS NO LIABILITY FOR
          ITS FAILURE TO MEET SUCH DATES. SUBSCRIPTION PLAN PURCHASER EXPRESSLY
          UNDERSTANDS AND AGREES THAT CARE EXCHANGE, INC DOES NOT WARRANT THAT
          THE CREATIVES OR SUBSCRIPTION PLANS ARE FREE OF CLAIMS OF PATENT,
          TRADEMARK, TRADE SECRET, COPYRIGHT, OR OTHER PROPRIETARY RIGHTS
          INFRINGEMENT BY A THIRD PARTY.
        </p>
        <p>
          6.2 CARE EXCHANGE, INC SHALL NOT HAVE ANY LIABILITY TO THE
          SUBSCRIPTION PLAN PURCHASER FOR LOST PROFITS OR OTHER CONSEQUENTIAL,
          SPECIAL, INDIRECT OR INCIDENTAL DAMAGES, BASED UPON A CLAIM OF ANY
          TYPE OR NATURE (INCLUDING BUT NOT LIMITED TO CONTRACT, TORT, STATUTE
          OR OTHERWISE, INCLUDING NEGLIGENCE, WARRANTY OR STRICT LIABILITY),
          INCLUDING (WITHOUT LIMITATION) LOSS OF OPERATION TIME AND LOSS OF
          GOODWILL OR ANTICIPATED SAVINGS, EVEN IF ADVISED OF THE POSSIBILITY OF
          SUCH DAMAGES AND NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF
          ANY REMEDY. IN NO EVENT SHALL CARE EXCHANGE, INC BE LIABLE ON ANY
          THEORY OF LIABILITY, WHETHER IN AN EQUITABLE, LEGAL, OR COMMON LAW
          ACTION ARISING HEREUNDER FOR CONTRACT, STRICT LIABILITY, INDEMNITY,
          TORT (INCLUDING NEGLIGENCE), OR OTHERWISE, FOR ANY DAMAGES IN EXCESS
          OF THE FEES PAID BY SUBSCRIPTION PLAN PURCHASER FOR THE SUBSCRIPTION
          PLANS IN THE THREE (3) MONTH PERIOD PRIOR TO THE CLAIM AND
          NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY REMEMDY.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>7. Term and Termination</h4>
        <p>
          7.1 This Agreement shall continue for a period of three (3) years from
          the Effective Date and shall automatically renew for additional three
          (3) year periods unless either party provides written notice of
          termination ninety (90) days prior to any renewal period.
        </p>
        <p>
          7.2 Care Exchange, Inc. reserves the right to terminate this Agreement
          immediately in the event (i) a Campaign does not meet minimum Campaign
          performance criteria; (ii) Subscription Plan Purchaser violates the
          payment terms set forth herein; or (iii) Care Exchange, Inc. provides
          ten (10) days written notice.
        </p>
        <p>
          7.3 This Agreement or any Purchase Order or order via the Portal
          hereunder may be terminated prior to expiration or completion in
          accordance with the following: (i) by either party if the other party
          files a petition for bankruptcy or insolvency, has an involuntary
          petition filed against it, commences an action providing for relief
          under bankruptcy laws, files for the appointment of a receiver, or is
          adjudicated a bankrupt concern; or (ii) by either party in the event
          the other has failed to perform any obligation required to be
          performed under this Agreement or Purchase Order or the Portal and
          such failure is not corrected within thirty (30) days from receipt of
          written notice advising of such failure from the other party.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>8. Proprietary Matters</h4>
        <p>
          8.1 Each party agrees at all times to keep strictly confidential all
          Confidential Information (as hereafter defined) belonging to the other
          party and Subscription Plan Purchaser agrees to keep strictly
          confidential all Confidential Information of Care Exchange, Inc and it
          Partners. "Confidential Information" shall mean any information,
          technical data or know-how including, but not limited to, that which
          comprises or relates to the other party's confidential and proprietary
          trade secrets, hardware, software (source code and object code),
          screens, specifications, designs, plans, drawings, data, prototypes,
          discoveries, research, developments, processes, procedures,
          intellectual property, market research, marketing techniques and
          plans, business plans and strategies, customer names and other
          information related to customers, price lists, pricing policies and
          financial information or other business and/or technical information
          and materials, in oral, demonstrative, written, electronic, graphic or
          machine-readable form and any analyses, compilations, studies or
          documents related thereto, including such information of Care
          Exchange, Inc and it Partners.
        </p>
        <p>
          8.2 Each party shall at all times protect and safeguard the
          Confidential Information of the other and agrees not to, in whole or
          in part, sell, lease, license, assign, transfer, or disclose the
          Confidential Information to any third party and shall not copy,
          reproduce or distribute the Confidential Information except as
          expressly permitted in this Agreement. Each party shall take every
          reasonable precaution to prevent the theft, disclosure, and the
          unauthorized copying, reproduction or distribution of the Confidential
          Information. The parties agree, however, that Care Exchange, Inc may
          disclose Confidential Information on a confidential basis to a
          consultant in connection with any work that the consultant is
          performing on behalf of Care Exchange, Inc or to Care Exchange, Inc’s
          Partners.
        </p>
        <p>
          8.3 Subscription Plan Purchaser agrees that it will not use any
          Confidential Information for its own purpose or for the benefit of any
          third party and shall honor the copyrights and other intellectual
          property rights of Care Exchange, Inc and/or a Care Exchange, Inc’s
          Partner.
        </p>
        <p>
          8.4 Without granting any right or license, the obligations of the
          parties hereunder shall not apply to any material or information that:
          (i) is, or at any time becomes, a part of the public domain through no
          act or omission of the receiving party; (ii) is independently
          discovered or developed by the receiving party without use of the
          disclosing party's Confidential Information; (iii) is rightfully
          obtained from a third party without any obligation of confidentiality;
          or (iv) is already known by the receiving party without any obligation
          of confidentiality prior to obtaining the Confidential Information
          from the disclosing party. In addition, neither party shall be liable
          for disclosure of Confidential Information if made in response to a
          valid order of a court or authorized agency of government, provided
          that notice is promptly given to the party whose Confidential
          Information is to be so disclosed so that such party may seek a
          protective order and/or engage in other efforts to minimize the
          required disclosure. The parties shall cooperate in seeking the
          protective order and engaging in such other efforts.
        </p>
        <p>
          8.5 Nothing in this Agreement shall preclude Care Exchange, Inc from
          using in any manner or for any purpose it deems necessary, the
          know-how, techniques, or procedures acquired or used by Care Exchange,
          Inc in the performance of services hereunder or providing the
          Campaigns.
        </p>
        <p>
          8.6 Any software (including object code and source code), HTML,
          marketing materials (including videos and other collateral promoting
          Advertiser products and services), and any other products provided to
          Advertiser by Care Exchange, Inc (collectively "Care Exchange, Inc
          Proprietary Property") shall be the sole property of Care Exchange,
          Inc and Care Exchange, Inc shall own all right, title, and interest in
          such Care Exchange, Inc Proprietary Property. Advertiser shall have
          the right to use such Care Exchange, Inc Proprietary Property solely
          any connection with the services provided by Care Exchange, Inc in
          connection with the Campaigns. Any other use of the Care Exchange, Inc
          Proprietary Property is strictly prohibited including, but not limited
          to, the use of the Care Exchange, Inc Proprietary Property by any
          other Advertiser affiliate, partner or agent. Upon termination or
          expiration of this Agreement, Advertiser's right to use the Care
          Exchange, Inc Proprietary Property shall immediately cease.
        </p>
        <p>
          8.7 Subscription Plan Purchaser acknowledges that the persons who have
          elected to co­ register or sign-up with Subscription Plan Purchaser
          also may have elected to register with Care Exchange, Inc and/or its
          Care Exchange, Inc’s Partners and may have elected to co­ register
          and/or sign up with additional Subscription Plan Purchasers.
          Therefore, Subscription Plan Purchaser acknowledges that Care
          Exchange, Inc and the Care Exchange, Inc’s Partners retain all rights
          to market and communicate to such persons, consistent with their
          policies and procedures.
        </p>
        <p>
          8.8 The parties agree and understand that a material breach of this
          Section will cause the non-breaching party to suffer irreparable harm
          and that monetary damages may be inadequate to compensate for such
          damage. Accordingly, the parties agree that in such event, the
          non-breaching party will, in addition to all other remedies, may be
          entitled to preliminary and permanent injunctive relief without the
          necessity of showing any actual damage or posting a bond. The
          foregoing remedy is a material, bargained for basis of this Agreement
          and has been taken into account in each party's decision to enter into
          this Agreement.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>9. Relationship</h4>
        <p>
          9.1 During the term of this Agreement and for a period of twelve (12)
          months after expiration or termination of this Agreement, Subscription
          Plan Purchaser shall not take any action to circumvent Care Exchange,
          Inc.'s relationships with the Care Exchange, Inc. Partners.
          Furthermore, Subscription Plan Purchaser shall not, directly or
          indirectly, work with, or accept any services from, any Care Exchange,
          Inc’s Partners without Care Exchange, Inc's prior written consent.
          This provision shall not apply to the extent Subscription Plan
          Purchaser is already working with Care Exchange, Inc’s Partners as of
          the Effective Date as evidenced by Subscription Plan Purchaser's
          written records which shall be provided to Care Exchange, Inc and
          which shall be accepted in Care Exchange, Inc's sole discretion.
        </p>
        <p>
          9.2 During the term of this Agreement and for twelve (12) months
          hereafter, Subscription Plan Purchaser agrees not to solicit, induce,
          recruit or encourage, directly or indirectly any online publisher, web
          site, network, or email provider that is affiliated with Care
          Exchange, Inc or any Care Exchange, Inc’s Partner to reduce or stop
          doing business with Care Exchange, Inc.
        </p>
        <h4 style={{ color: "#bfc3cb", fontWeight: "600" }}>10. Miscellaneous</h4>
        <p>
          10.1 Except for Subscription Plan Purchaser's payment obligations,
          neither party shall be liable for, or considered in breach of or
          default under this Agreement on account of, any delay or failure to
          perform as required as a result of any causes or conditions which are
          beyond such party's reasonable control and which such party is unable
          to overcome by the exercise of reasonable diligence (including without
          limitation, the failure of any Care Exchange, Inc’s Partners to
          display or place a Campaign).
        </p>
        <p>
          10.2 This Agreement shall be governed by the laws of the state of
          California without regard to the conflict of laws provisions of any
          state or jurisdiction. The parties consent to have all disputes
          regarding this agreement resolved by binding arbitration before the
          American Arbitration Association, Commercial Division in Los Angeles,
          California. The parties specifically waive any international treaties
          or other international law, which may govern the court or location of
          resolution of any dispute between them. The parties waive the personal
          service of any process upon them and agree that service may be
          completed by overnight mail (using a commercially recognized service)
          or by U.S. mail with delivery receipt to the address stated in this
          Agreement.
        </p>
        <p>
          10.3 All notices, requests, demands, and other communications
          hereunder shall be in writing and shall be deemed given at the time
          such communication is sent by registered or certified mail (return
          receipt requested), or recognized national overnight courier service,
          or delivered personally, to the following addresses (or at such other
          address for a party as shall be specified by like notice: (i) if to
          Care Exchange, Inc., to the attention of both the CEO and CFO at 10970
          Arrow Route, Suite 206, Rancho Cucamonga, CA 91730; and (ii) if to
          Subscription Plan Purchaser, to the attention of the contact
          information in the Purchase Order.
        </p>
        <p>
          10.4 Subscription Plan Purchaser shall not assign or transfer this
          Agreement or any Purchase Order without the prior written consent of
          Care Exchange, Inc. Any attempt to assign or transfer this Agreement
          by Subscription Plan Purchaser shall be void.
        </p>
        <p>
          10.5 Each party is an independent contractor. Any intention to create
          a joint venture or partnership between the parties is expressly
          disclaimed. Except as set forth herein, neither party is authorized or
          empowered to obligate the other or to incur any costs on behalf of the
          other without the other party's prior written consent.
        </p>
        <p>
          10.6 This Agreement exhibits or addendum thereto and applicable
          Purchase Orders constitutes a valid and binding agreement between the
          parties, and has been duly executed by an authorized representative of
          each party. This Agreement and any exhibits or addenda thereto is
          intended to be the parties' complete, integrated expression of the
          terms of their agreement and any prior agreements or understandings
          with respect to such subject matters are superseded hereby and fully
          merged herein, and may only be modified in writing by authorized
          representatives of the parties.
        </p>
        <p>
          10.7 Any obligations which expressly or by their nature are to
          continue after termination, cancellation, or expiration of this
          Agreement shall survive and remain in effect after such happening,
          including without limitation, Sections 1.1, 4, 5, 6, 8, 9, and 10.
          Each party acknowledges that the provisions of this Agreement were
          negotiated to reflect an informed, voluntary allocation between them
          of all the risks (both known and unknown) associated with the
          transactions contemplated hereunder. In the event that any provision
          of this Agreement conflicts with the law under which the Agreement is
          to be construed or if any such provision is held invalid or
          unenforceable by a court with jurisdiction over the parties to the
          Agreement, (i) such provision will be restated to reflect as nearly as
          possible the original intentions of the parties in accordance with
          applicable law; and (ii) the remaining terms, provisions, covenants,
          and restrictions of the Agreement will remain in full force and
          effect.
        </p>
        <p>
          10.8 During the term of this Agreement and for a period of two (2)
          years thereafter, Subscription Plan Purchaser agrees not to hire,
          solicit, nor attempt to solicit, the services of any employee or
          consultant of Care Exchange, Inc. without the prior written consent of
          Care Exchange, Inc. Subscription Plan Purchaser further agrees not to
          hire, solicit, nor attempt to solicit, the services of any former
          employee or consultant of Care Exchange, Inc. for a period of one (1)
          year from such former employee's or consultant's last date of service
          with Care Exchange, Inc.
        </p>
        <p>
          10.9 Except as otherwise specified, the rights and remedies granted to
          a party under this Agreement are cumulative and in addition to, not in
          lieu of, any other rights and remedies which the party may possess at
          law or in equity. Failure of either party to require strict
          performance by the other party of any provision shall not affect the
          first party's right to require strict performance thereafter. Waiver
          by either party of a breach of any provision shall not waive either
          the provision itself or any subsequent breach.
        </p>
        <p>
          10.10 This Agreement may be executed in any number of counterparts,
          each of which when so executed and delivered shall be deemed an
          original, and such counterparts together shall constitute one and the
          same instrument. For purposes hereof, a facsimile copy or electronic
          scan of this Agreement shall be deemed to be an original.
        </p>
        <p>
          10.11 Care Exchange, Inc reserves the right, at its sole discretion,
          to modify this Agreement at any time by posting a notice on the
          Portal, or by sending Subscription Plan Purchaser a notice via email
          or postal mail. Any continued receipt of Subscription Plans or access
          to the Portal shall be deemed Subscription Plan Purchaser's consent to
          the modified terms and conditions.
        </p>
        <p>
          10.12 In the event that Care Exchange, Inc. is required to digitally
          sign, accept, or acknowledge additional terms when using Advertiser's
          online advertising network or accessing Campaigns or Creatives, the
          parties acknowledge and agree that such digital agreement or
          acknowledgement is null and void and in no way binding on Care
          Exchange, Inc. Therefore, any terms which appear on such digital
          agreement are to be disregarded and deemed non-effective.
        </p>
      </div>
    </div>
  );
};

export default Subscription;
